﻿/// <reference path="../commonClasses/common.interface.ts" />
/// <reference path="../commonClasses/commonDataServiceBase.ts" />

module Meevo.Components.Common {

    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import IPayrollPeriod = Meevo.Plugins.Payroll.IPayrollPeriod;

    export interface IPayRollYear {
        endOfYear: string | Date;
        payrollYear: number;
        startOfYear: string | Date;
    }

    export interface IPayRollListItem extends ReportCOPayrollListPage {
        locationId: number;
        objectCreationType: number;
        objectState: number;
        payrollEndDate: string | Date;
        payrollPeriodId: string;
        payrollStartDate: string | Date;
        payrollStatus: number;
        payrollTypeEnum: number;
        processingHeaderCount: number;
        retailHeaderCount: number;
        serviceHeaderCount: number;
        serviceRetailHeaderCount: number;
        totalHeaders: number;
        payrollPeriod_LId: any;
        dateRange: any;
        serviceRetail: any;
    }

    export interface IPayrollEmployee {
        displayName: string;
        employeeFirstName: string;
        employeeId: string;
        employeeLastName: string;
        id: string;
    }

    export interface IPeyRollLIstRequestBody {
        StartDate: string | Date;
        EndDate: string | Date;
    }

    export interface ReportCOPayrollListPage
    {
        tenantId: number;
        multiStartDate: string | Date;
        multiEndDate: string | Date;
        locationForHierarchy: any[];
        storeName: string;
        copayrollEnum: string;
    }

    export interface ReportCOPayrollEmployeeeListPage
    {
    }

    export class PayRollService extends Meevo.Components.CommonClasses.CommonDataServiceBase implements Meevo.Components.CommonClasses.ICommonDataService {
        static factory(): Function {
            let payRollService = (appSettings: Meevo.Components.Common.IAppSettings, $http: angular.IHttpService, dataService, identityService: Meevo.Components.Common.IIdentityService) => {
                return new PayRollService(appSettings, $http, dataService, identityService);
            };

            payRollService.$inject = [
                'meevo.AppSettings',
                '$http',
                'meevo.components.common.DataService',
                'meevo.components.common.IdentityService'
            ];
            return payRollService;
        }
        private payrollsettingsDataService: Meevo.Components.CommonClasses.ICompensationSettingsService;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected $http: angular.IHttpService,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected identityService: Meevo.Components.Common.IIdentityService) {
            super(appSettings, $http);
        }

        getPayRollYears(): angular.IPromise<IPayRollYear[]> {
            return this.dataService
                .customMethodData(`api/Report/PayrollYear/List`, 'post', null)
                .then(response => response.data);
        }

        getPayRollList(data: IPeyRollLIstRequestBody): angular.IPromise<IPayRollListItem[]> {
            return this.dataService
                .customMethodData(`api/Report/Payroll/List`, 'post', {criteria: data})
                .then((response) => {
                    return response.data
                });
        }

        getCOPayRollList(data: ReportCOPayrollListPage): angular.IPromise<IPayRollListItem[]> {
            return this.dataService
                .customMethodData(`api/Report/COPayroll/List`, 'post',  data)
                .then(response => response.data);
        }

        getCOPayrollEmployeeList(data: ReportCOPayrollEmployeeeListPage): angular.IPromise<IPayRollListItem> {
            return this.dataService
                .customMethodData(`api/Report/COPayrollEmployee/List`, 'post', data)
                .then(response => response.data);
        }

        getPayrollSettings(): angular.IPromise<any> {
            return this.dataService.getSettings(Model.BusinessSettingCategoryEnum.Period, null);
        }

        public submitToAdp(period: IPayrollPeriod, employeePayId: string = null): angular.IPromise<any> {
            const payrollSubmitPayload = {
                payrollPeriodId: period.payrollPeriodId,
                payrollStartDate: period.payrollStartDate,
                payrollEndDate: period.payrollEndDate,  
                specificEmployeeId: employeePayId,                
                payrollFrequency: period.payrollFrequencyEnum
            };
            return this.dataService.customMethodData(`api/Payroll/${period.payrollPeriodId}/Adp/Submit`, 'post', payrollSubmitPayload);
        }

        public getAdpSubmitLog(payrollPeriodId: Guid): angular.IPromise<any> {
            return this.dataService.customMethodData(`api/Payroll/Adp/Log/${payrollPeriodId}`, 'get', null);
        }
    }

    angular.module('meevo.components.common')
        .factory('meevo.components.common.PayRollService', PayRollService.factory());
}